import { z } from 'zod';
import { Validation } from '@mews/framework';
import { updateSchema as commonUpdateSchema, recipientEmailsSchema } from '../common/schemas';

export const schema = z.object({
    name: Validation.String.Empty.default(''),
    resourceCategoryIds: z.array(z.string()).min(1).default([]),
    serviceId: Validation.String.Required.default(''),
    notes: Validation.String.Empty.default(''),
    enterpriseCode: Validation.String.Empty.default(''),
    czechForeignPoliceReportIdShort: Validation.String.Required.default(''),
    receiverEmails: recipientEmailsSchema.default(''),
    dailyReportExecutionTime: Validation.String.Required.default(''),
});

export type FormValues = z.infer<typeof schema>;

export const updateSchema = schema.merge(commonUpdateSchema);

export type UpdateFormValues = z.infer<typeof updateSchema>;
export type UpdateFormValuesInput = z.input<typeof updateSchema>;
